const CTE = {
    PROTOCOL: {
        VERSION: 1,
    },
    PERMISSIONS: {
        PERMISSION_GRANTED: "granted",
        PERMISSION_REQUESTED: "prompt",
        PERMISSION_DENIED: "denied",
        LOCATION_GETTED: "location_getted",
        PERMISSION_CHANGED: "permission_changed",
    },
    GEOLOCATION_POSITION_ERRORS: {
        GENERAL_ERROR: 0,
        PERMISSION_DENIED: 1,
        POSITION_UNAVAILABLE: 2,
        TIMEOUT: 3,
    },
    CONTENT_TYPE: {
        LINK: "LINK",
        DOCUMENT: "DOCUMENT",
        IMAGE: "IMAGE",
        VIDEO: "VIDEO",
        NOTE: "NOTE",
        PLAIN: "PLAIN",
        OPTIONS: "OPTIONS",
        MAP: "LOCALIZATION_WIDGET_MESSAGE",
        ATTACHMENT: "ATTACHMENT",
        ITEMS_CAROUSEL_MESSAGE: "ITEMS_CAROUSEL_MESSAGE",
        TEXT: "TEXT",
        AUDIO: "AUDIO",
    },
    MESSAGE_TYPE: {
        PLAIN_MESSAGE: "PLAIN_MESSAGE",
        QUESTION_ANSWER: "QUESTION_ANSWER",
    },
    MESSAGE_ONWER: {
        DEFAULT_ASSISTANT: "DEFAULT_ASSISTANT",
        ASSISTANT: "ASSISTANT",
        END_USER: "END_USER",
    },
    USER_TYPE: {
        AGENT: 0,
        USER: 1,
    },
    AUDIO_RECORD_STATES: {
        DISABLED: "DISABLED",
        BLOCKED: "BLOCKED",
        RECORDING: "RECORDING",
        PENDING: "PENDING",
        CANCEL: "CANCEL",
        FINISH: "FINISH",
    },
};

export default CTE;
